import { recordPath, recordRoute } from '@/shared/registry'

/** Where the enrollment and plan custom field pages live. */
export const customFieldsPath = '/entitlements/custom-fields'
export const createCustomFieldPath = `${customFieldsPath}/new`
export const customFieldRoute = recordRoute('entitlements', 'custom-fields')
export const editCustomFieldRoute = `${customFieldRoute}/edit`

/** A custom field's details page. */
export function customFieldPath(id: string): string {
  return recordPath('entitlements', 'custom-fields', id)
}

/** A custom field's edit page. */
export function editCustomFieldPath(id: string): string {
  return `${customFieldPath(id)}/edit`
}

/** The base of Custom Field Details' slots (`detailsSlots`). */
export const customFieldDetailsSlot = 'entitlements.custom-field-details'

/** The API's custom field endpoints: a GET finds them, a POST creates one. */
export const customFieldsApi = '/entitlements/v1/custom-fields'

export function customFieldApi(id: string): string {
  return `${customFieldsApi}/${encodeURIComponent(id)}`
}

/** Which records a field is on. */
export const recordKinds = ['enrollment', 'plan'] as const

export type RecordKind = (typeof recordKinds)[number]

/** A record's custom fields and values: GET reads them, PUT replaces the values at the record's version. */
export function recordCustomFieldValuesApi(kind: RecordKind, recordId: string): string {
  return `/entitlements/v1/${kind === 'enrollment' ? 'enrollments' : 'plans'}/${encodeURIComponent(recordId)}/custom-fields`
}

/**
 * The enabled fields a new record has that the viewer fills in, as Create shows them: a new
 * enrollment's by its class, a new plan's by its organization.
 */
export function availableCustomFieldsApi(kind: RecordKind, scopeId: string): string {
  return kind === 'enrollment'
    ? `/entitlements/v1/classes/${encodeURIComponent(scopeId)}/enrollment-custom-fields`
    : `/entitlements/v1/organizations/${encodeURIComponent(scopeId)}/plan-custom-fields`
}

/** What each definition action needs, by the field's owner organization; a record's values go with the record. */
export const readCustomFieldsPermission = 'entitlements.custom-fields.read'
export const writeCustomFieldsPermission = 'entitlements.custom-fields.write'
export const deleteCustomFieldsPermission = 'entitlements.custom-fields.delete'
